import {defineRule} from 'vee-validate'
import {required, email, min, max} from '@vee-validate/rules'

export default defineNuxtPlugin(nuxtApp => {
  defineRule('required', value => {
    if (!value || !value.length) {
      return '필수 입력 항목입니다.'
    }
    return true
  })
  defineRule('email', value => {
    // The field is empty so it should pass
    if (!value || !value.length) {
      return true
    }
    if (!/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/.test(value)) {
      return '이메일을 올바르게 입력해주세요.'
    }
    return true
  })
  defineRule('min', (value, [limit]) => {
    // The field is empty so it should pass
    if (!value || !value.length) {
      return true
    }
    if (value.length < limit) {
      return `최소 ${limit}자 이상 입력해주세요`
    }
    return true
  })
  defineRule('max', (value, [limit]) => {
    // The field is empty so it should pass
    if (!value || !value.length) {
      return true
    }
    if (value.length > limit) {
      return `최대 ${limit}자 이하로 입력해주세요`
    }
    return true
  })
})
